import { lazy } from "react";
import SuspenseWrapper from "components/SuspenseWrapper";

const PromoCodes = lazy(() => import("../modules/promo-codes/PromoCodes"));
export default function PromoCodesPage() {
  return (
    <SuspenseWrapper>
      <PromoCodes />
    </SuspenseWrapper>
  );
}
